import React, { useState } from 'react'
import api from '../api/api.login'
import './auth.login.css'


function Login () {
  const [username,setUsername] = useState('')
  const [password,setPassword] = useState('')
  function onSubmit (e) {
    e.preventDefault()
    let data={
        username:username,
        password:password
    }
    
    api.loginUser(data)
  }
  return (
    <form onSubmit={onSubmit}>
      <div class='limiter'>
        <div class='container-login100'>
          <div class='wrap-login100'>
            <h4 style={{'margin-bottom':'20px'}}>INSURANCE APPROVALS</h4>
            <span
              class='login100-form-title p-b-26'
              style={{ 'font-family': 'Teko', 'line-height': '3 !important' }}
            >
              {/* <img src='./engagelogin.png' width='80%' /> */}
            </span>
            <div
              class='wrap-input100 validate-input'
              data-validate='Valid email is: a@b.c'
            >
              <input
                class='input100'
                type='text'
                placeholder='Username'
                autocomplete='off'
                value={username}
                style={{ 'font-family': 'Roboto' }}
                onChange={e => setUsername(e.target.value)}
              />
            </div>

            <div
              class='wrap-input100 validate-input'
              data-validate='Enter password'
            >
              <input
                class='input100'
                type='password'
                placeholder='Password'
                autocomplete='off'
                value={password}
                style={{ 'font-family': 'Roboto' }}
                onChange={e => setPassword(e.target.value)}
              />
            </div>

            <div class='container-login100-form-btn'>
              <div class='wrap-login100-form-btn'>
                <div
                  class='login100-form-bgbtn'
                  style={{ background: '#BE0D0D' }}
                ></div>

                <button
                  class='login100-form-btn'
                  id='login'
                  style={{ 'font-family': 'Roboto' }}
                >
                  Login
                </button>
              </div>
              {/* <a
                href='/register'
                style={{ 'margin-top': '10px', 'font-family': 'Roboto' }}
              >
                Create an account
              </a>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <a
                href='/forgot'
                style={{ 'margin-top': '10px', 'font-family': 'Roboto' }}
              >
                Forgot Password?
              </a> */}
            </div>
            <span
              class='login100-form-title p-b-48'
              style={{ 'padding-bottom': '0px !important' }}
            >
              {/* <img
                src='./logo-al-zaabi-small-dark.png'
                style={{ width: '40%', 'margin-top': '20px' }}
              /> */}
            </span>
            {/* <div style={{"text-align":"center"}}>
                    <a style={{"font-family":"Roboto"}} id="extensiondwnld" download>Download Extension!</a>
                </div> */}
          </div>
        </div>
      </div>
    </form>
  )
}
export default Login;
